import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "user-management" }
const _hoisted_2 = { class: "user-search-bar" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["disabled", "onClick"]
const _hoisted_8 = ["disabled", "onClick"]
const _hoisted_9 = { class: "admin-modal" }
const _hoisted_10 = { class: "admin-preset" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "admin-error"
}
const _hoisted_13 = {
  key: 1,
  class: "admin-warn"
}
const _hoisted_14 = { class: "admin-modal__actions" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "admin-modal" }
const _hoisted_17 = {
  key: 0,
  class: "admin-error"
}
const _hoisted_18 = {
  key: 1,
  class: "admin-warn"
}
const _hoisted_19 = { class: "admin-modal__actions" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
        class: "user-search-input",
        placeholder: "搜索用户名/邮箱/昵称",
        onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.searchQuery]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pointsMin) = $event)),
        type: "number",
        class: "user-search-input user-search-input--small",
        placeholder: "最低积分"
      }, null, 512), [
        [
          _vModelText,
          _ctx.pointsMin,
          void 0,
          { number: true }
        ]
      ]),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pointsMax) = $event)),
        type: "number",
        class: "user-search-input user-search-input--small",
        placeholder: "最高积分"
      }, null, 512), [
        [
          _vModelText,
          _ctx.pointsMax,
          void 0,
          { number: true }
        ]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "user-search-btn",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleSearch && _ctx.handleSearch(...args)))
      }, "搜索"),
      _cache[17] || (_cache[17] = _createElementVNode("span", { class: "user-batch-divider" }, null, -1)),
      _createElementVNode("button", {
        type: "button",
        class: "user-batch-btn user-batch-btn--danger",
        disabled: _ctx.selectedRowKeys.length === 0 || _ctx.batchOperating,
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.runBatch(true)))
      }, _toDisplayString(_ctx.batchArmed && _ctx.batchArmedKind === 'disable' ? '再次点击确认禁用' : `批量禁用${_ctx.selectedRowKeys.length ? `(${_ctx.selectedRowKeys.length})` : ''}`), 9, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: "user-batch-btn",
        disabled: _ctx.selectedRowKeys.length === 0 || _ctx.batchOperating,
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.runBatch(false)))
      }, _toDisplayString(_ctx.batchArmed && _ctx.batchArmedKind === 'enable' ? '再次点击确认启用' : `批量启用${_ctx.selectedRowKeys.length ? `(${_ctx.selectedRowKeys.length})` : ''}`), 9, _hoisted_4)
    ]),
    _createVNode(_component_DataTable, {
      columns: _ctx.columns,
      "data-source": _ctx.users,
      loading: _ctx.loading,
      total: _ctx.total,
      current: _ctx.page,
      "page-size": _ctx.pageSize,
      "row-selection": _ctx.rowSelection,
      "empty-text": "暂无用户数据",
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.key === 'emailOrUsername')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(record.email || record.username || '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'nickname')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(record.nickname || '-'), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'role')
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass(['admin-role', { 'admin-role--admin': record.role === 'admin' }])
            }, _toDisplayString(record.role === 'admin' ? '管理员' : '用户'), 3))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              class: _normalizeClass(['user-status', { 'user-status--disabled': record.is_disabled }])
            }, _toDisplayString(record.is_disabled ? '已禁用' : '正常'), 3))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.openPointsModal(record))
              }, "分配积分", 8, _hoisted_5),
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (_ctx.openDeductModal(record))
              }, "扣减积分", 8, _hoisted_6),
              _createElementVNode("button", {
                type: "button",
                disabled: record.role === 'admin' || _ctx.disableToggling,
                onClick: ($event: any) => (_ctx.toggleDisable(record))
              }, _toDisplayString(_ctx.disableArmedId === record.id ? '再次确认' : (record.is_disabled ? '启用' : '禁用')), 9, _hoisted_7),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.roleTogglingUserId === record.id,
                onClick: ($event: any) => (_ctx.toggleRole(record))
              }, _toDisplayString(record.role === 'admin' ? '取消管理员' : '设为管理员'), 9, _hoisted_8)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["columns", "data-source", "loading", "total", "current", "page-size", "row-selection", "onChange"]),
    (_ctx.pointsModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "admin-modal-overlay",
          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.pointsModalVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("h3", null, "为 " + _toDisplayString(_ctx.selectedUser?.email || _ctx.selectedUser?.username || _ctx.selectedUser?.id) + " 充值额度", 1),
            _cache[18] || (_cache[18] = _createElementVNode("p", null, "正数充值，仅支持增加额度", -1)),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presetAmounts, (preset) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: preset,
                  type: "button",
                  class: _normalizeClass(['admin-preset-btn', { 'admin-preset-btn--active': _ctx.pointsAmount === preset }]),
                  onClick: ($event: any) => (_ctx.pointsAmount = preset)
                }, _toDisplayString(preset), 11, _hoisted_11))
              }), 128))
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.pointsAmount) = $event)),
              type: "number",
              min: "1",
              step: "1",
              placeholder: "自定义额度（正整数）"
            }, null, 512), [
              [
                _vModelText,
                _ctx.pointsAmount,
                void 0,
                { number: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.pointsReason) = $event)),
              type: "text",
              placeholder: "原因（必填）"
            }, null, 512), [
              [_vModelText, _ctx.pointsReason]
            ]),
            (_ctx.pointsError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(_ctx.pointsError), 1))
              : _createCommentVNode("", true),
            (_ctx.confirmArmed)
              ? (_openBlock(), _createElementBlock("p", _hoisted_13, "已锁定 " + _toDisplayString(_ctx.pointsAmount) + " 额度，再次点击确认充值", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pointsModalVisible = false))
              }, "取消"),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.pointsSaving || !_ctx.pointsAmount || _ctx.pointsAmount < 1 || !_ctx.pointsReason.trim(),
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.savePoints && _ctx.savePoints(...args)))
              }, _toDisplayString(_ctx.confirmArmed ? '再次点击确认' : '确认充值'), 9, _hoisted_15)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.deductModalVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "admin-modal-overlay",
          onClick: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.deductModalVisible = false), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("h3", null, "扣减 " + _toDisplayString(_ctx.deductUser?.email || _ctx.deductUser?.id) + " 的积分", 1),
            _createElementVNode("p", null, "当前余额 " + _toDisplayString(_ctx.deductUser?.points) + "，扣减后余额 " + _toDisplayString(_ctx.deductPreview), 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.deductAmount) = $event)),
              type: "number",
              min: "1",
              step: "1",
              placeholder: "扣减额度（正整数）"
            }, null, 512), [
              [
                _vModelText,
                _ctx.deductAmount,
                void 0,
                { number: true }
              ]
            ]),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.deductReason) = $event)),
              type: "text",
              placeholder: "原因（必填）"
            }, null, 512), [
              [_vModelText, _ctx.deductReason]
            ]),
            (_ctx.deductError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.deductError), 1))
              : _createCommentVNode("", true),
            (_ctx.deductArmed)
              ? (_openBlock(), _createElementBlock("p", _hoisted_18, "将扣减 " + _toDisplayString(Math.floor(_ctx.deductAmount)) + " 积分，再次点击确认", 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.deductModalVisible = false))
              }, "取消"),
              _createElementVNode("button", {
                type: "button",
                disabled: _ctx.deductSaving || !_ctx.deductAmount || _ctx.deductAmount < 1 || !_ctx.deductReason.trim() || _ctx.deductPreview < 0,
                onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.saveDeduct && _ctx.saveDeduct(...args)))
              }, _toDisplayString(_ctx.deductArmed ? '再次点击确认' : '确认扣减'), 9, _hoisted_20)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}